var map = {
	"./banner.jpg": "301c",
	"./blank.gif": "76d6",
	"./cga23viewpoint.png": "1d81",
	"./chi23datavideo.png": "c6dd",
	"./gallery00-1.jpg": "a852",
	"./gallery01-1.jpg": "7e92",
	"./gallery01.jpg": "3714",
	"./gallery02-1.jpg": "70d3",
	"./gallery02.jpg": "32ec",
	"./gallery03-1.jpg": "481c",
	"./gallery03.jpg": "0098",
	"./gallery04-1.jpg": "0096",
	"./gallery04.jpg": "9996",
	"./gallery05-1.jpg": "e7fb",
	"./gallery06-1.jpg": "73b6",
	"./gallery06.jpg": "de5d",
	"./gallery07-1.jpg": "2753",
	"./gallery08-1.jpg": "6d23",
	"./gallery09-1.jpg": "a6be",
	"./gallery10-1.jpg": "0cd5",
	"./gallery11-1.jpg": "0939",
	"./gallery12-1.jpg": "e6d0",
	"./gallery12.jpg": "59e1",
	"./gallery13-1.jpg": "92f5",
	"./gallery14-1.jpg": "b7ef",
	"./gallery15-1.jpg": "2ac4",
	"./gallery15.jpg": "40ca",
	"./gallery16-1.jpg": "aa58",
	"./gallery16.jpg": "32d7",
	"./gallery17-1.jpg": "704b",
	"./gallery17.jpg": "d127",
	"./gallery18-1.jpg": "9bf0",
	"./gallery18.jpg": "c47e",
	"./gallery19-1.jpg": "9f4f",
	"./gallery19.jpg": "d5e3",
	"./gallery20-1.jpg": "020b",
	"./gallery20.jpg": "aec0",
	"./gallery21-1.jpg": "5df4",
	"./gallery21.jpg": "45c5",
	"./icons8-Multiply-50.png": "9cf4",
	"./loader.gif": "95cd",
	"./loading.gif": "12ae",
	"./man.jpg": "93d9",
	"./nav.png": "368a",
	"./pvis2023vrvideo.png": "19f0",
	"./social-icons.png": "1a98",
	"./tvcg23dminer.png": "add5",
	"./vis23InkSight.png": "4d30",
	"./vis23attentionviz.png": "1bf8",
	"./work2016MagicMirror.jpg": "c843",
	"./work2018Pulse.png": "19a5",
	"./work2018TED.png": "f145",
	"./work2019EmoCo.png": "dec0",
	"./work2019SLens.png": "4a63",
	"./work2020CHIVoiceCoach.png": "94b6",
	"./work2020gif.gif": "0a60",
	"./work2020gif.png": "55a0",
	"./work2020mvf.png": "e1e8",
	"./work2021Intro.png": "92b5",
	"./work2021LQ2.jpg": "dd69",
	"./work2021LQ2.png": "49f1",
	"./work2021Survey.png": "bede",
	"./work2021multivision.gif": "b8df",
	"./work2021multivision.jpg": "446e",
	"./work2022-chi-math.gif": "1bf6",
	"./work2022-chi-retrieval.png": "d658",
	"./work2022-euro-mis.png": "855d",
	"./work2022-tvcg-gesture.png": "6549",
	"./work2022dashbot.png": "0ed1",
	"./work2022revast.png": "de3b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";